import React from 'react';
import { ClerkProvider } from '@clerk/clerk-react';
import { dark } from '@clerk/themes';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import SteamGameBrowser from './components/SteamGameBrowser';

const clerkPubKey = 'pk_test_cXVpZXQtbWFzdGlmZi04MC5jbGVyay5hY2NvdW50cy5kZXYk';
//const clerkPubKey = 'pk_live_Y2xlcmsuaW5kaWUuaW8k';

// Create a theme instance.
const theme = createTheme({
  palette: {
    mode: 'dark'
  },
});

function App() {
  if (!clerkPubKey) {
    console.error("Missing Clerk Publishable Key");
    return <div>Error: Missing Clerk Publishable Key</div>;
  }

  return (
    <ClerkProvider 
      publishableKey={clerkPubKey}
      appearance={{
        layout: {
          logoImageUrl: "logo.png"
        },
        variables: {
          colorPrimary: '#f4364c',
          colorBackground: '#222222',
          colorText: '#ffffff',
          colorInputText: '#ffffff',
          colorInputBackground: '#333333',
          fontFamily: 'Roboto, sans-serif',
        },
        elements: {
          formButtonPrimary: 
            'bg-primary hover:bg-primary-dark text-sm normal-case',
          card: 'bg-card-background shadow-xl',
          headerTitle: 'text-2xl font-semibold text-center',
          headerSubtitle: 'text-center',
          socialButtonsBlockButton: 
            'border-2 border-border-color bg-transparent hover:bg-primary-dark',
          formFieldInput: 'bg-input-background text-sm',
          footerActionLink: 'text-primary hover:text-primary-dark',
          identityPreviewEditButton: 'text-xs normal-case',
        }
      }}
    >
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <SteamGameBrowser />
      </ThemeProvider>
    </ClerkProvider>
  );
}

export default App;